export const BANNERS_DISPONIBLES = [
    { id: 'ninguno', nombre: 'Sin Foto', url: null },
    { id: 'fast-food', nombre: 'Hamburguesas', url: 'https://komity.cl/imgs/header_fast_food.jpg' },
    { id: 'Verdureria', nombre: 'Verduras', url: 'https://komity.cl/imgs/header_verduleria.jpg' },
    { id: 'sushi', nombre: 'Sushi / Oriental', url: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?q=80&w=800&auto=format&fit=crop' },
    { id: 'pasteleria', nombre: 'Pastelería', url: 'https://images.unsplash.com/photo-1587668178277-295251f900ce?q=80&w=800&auto=format&fit=crop' },
    { id: 'carnes', nombre: 'Carnes / Parrilla', url: 'https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?q=80&w=800&auto=format&fit=crop' },
    { id: 'copas', nombre: 'Copas / Bebidas', url: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?q=80&w=800&auto=format&fit=crop' },
];

export const TEMAS_PREDEFINIDOS = [
    {
        id: 'clasico', nombre: 'Clásico', descripcion: 'Azul profesional', emoji: '🔵',
        colores: {
            color_primario: '#0066FF', color_secundario: '#6C757D', color_fondo: '#f4f7f6',
            color_texto: '#1a1c1d', color_btn_primario: '#000000', color_btn_texto: '#ffffff',
            btn_continuar_bg: '#198754', btn_continuar_texto: '#ffffff',
            categoria_activa_bg: '#000000', categoria_activa_texto: '#ffffff',
            categoria_inactiva_bg: '#f1f3f5', categoria_inactiva_texto: '#495057',
        }
    },
    {
        id: 'oscuro', nombre: 'Oscuro Elegante', descripcion: 'Para bares y nocturnos', emoji: '🌙',
        colores: {
            color_primario: '#BB86FC', color_secundario: '#03DAC6', color_fondo: '#121212',
            color_texto: '#E1E1E1', color_btn_primario: '#BB86FC', color_btn_texto: '#000000',
            btn_continuar_bg: '#03DAC6', btn_continuar_texto: '#000000',
            categoria_activa_bg: '#BB86FC', categoria_activa_texto: '#000000',
            categoria_inactiva_bg: '#2D2D2D', categoria_inactiva_texto: '#BBBBBB',
        }
    },
    {
        id: 'naturaleza', nombre: 'Natural Verde', descripcion: 'Para verdulerías', emoji: '🌿',
        colores: {
            color_primario: '#2E7D32', color_secundario: '#558B2F', color_fondo: '#F1F8E9',
            color_texto: '#1B5E20', color_btn_primario: '#2E7D32', color_btn_texto: '#ffffff',
            btn_continuar_bg: '#558B2F', btn_continuar_texto: '#ffffff',
            categoria_activa_bg: '#2E7D32', categoria_activa_texto: '#ffffff',
            categoria_inactiva_bg: '#DCEDC8', categoria_inactiva_texto: '#33691E',
        }
    },
    {
        id: 'calido', nombre: 'Cálido Acogedor', descripcion: 'Para cafeterías', emoji: '☕',
        colores: {
            color_primario: '#A0522D', color_secundario: '#D2691E', color_fondo: '#FFF8F0',
            color_texto: '#3E2723', color_btn_primario: '#A0522D', color_btn_texto: '#ffffff',
            btn_continuar_bg: '#D2691E', btn_continuar_texto: '#ffffff',
            categoria_activa_bg: '#A0522D', categoria_activa_texto: '#ffffff',
            categoria_inactiva_bg: '#FFECB3', categoria_inactiva_texto: '#5D4037',
        }
    },
    {
        id: 'fiesta', nombre: 'Fiesta', descripcion: 'Colores vibrantes', emoji: '🎉',
        colores: {
            color_primario: '#FF6F00', color_secundario: '#E91E63', color_fondo: '#FFFDE7',
            color_texto: '#1a1c1d', color_btn_primario: '#FF6F00', color_btn_texto: '#ffffff',
            btn_continuar_bg: '#E91E63', btn_continuar_texto: '#ffffff',
            categoria_activa_bg: '#FF6F00', categoria_activa_texto: '#ffffff',
            categoria_inactiva_bg: '#FFF9C4', categoria_inactiva_texto: '#E65100',
        }
    },
    {
        id: 'minimal', nombre: 'Minimal Blanco', descripcion: 'Elegante y moderno', emoji: '⚪',
        colores: {
            color_primario: '#1a1a1a', color_secundario: '#666666', color_fondo: '#ffffff',
            color_texto: '#1a1a1a', color_btn_primario: '#1a1a1a', color_btn_texto: '#ffffff',
            btn_continuar_bg: '#1a1a1a', btn_continuar_texto: '#ffffff',
            categoria_activa_bg: '#1a1a1a', categoria_activa_texto: '#ffffff',
            categoria_inactiva_bg: '#f5f5f5', categoria_inactiva_texto: '#666666',
        }
    },
];

export const PLANTILLAS_CARTA = [
    {
        id: 'komity', nombre: 'Komity', descripcion: 'El clásico naranja',
        preview: { bg: '#F26B21', text: '#FFFFFF', footer: '#1a1c1d' },
        carta_qr: { header_bg: '#F26B21', header_text_color: '#FFFFFF', footer_bg: '#1a1c1d', footer_text_color: '#FFFFFF', color_fondo: '#F8F9FA', logo_tamano: 'mediano', tarjeta_radio: 'redondeado', tarjeta_sombra: false }
    },
    {
        id: 'noche', nombre: 'Noche', descripcion: 'Bares y vida nocturna',
        preview: { bg: '#1a1c1d', text: '#BB86FC', footer: '#111111' },
        carta_qr: { header_bg: '#1a1c1d', header_text_color: '#BB86FC', footer_bg: '#111111', footer_text_color: '#BB86FC', color_fondo: '#121212', logo_tamano: 'mediano', tarjeta_radio: 'redondeado', tarjeta_sombra: true }
    },
    {
        id: 'natural', nombre: 'Natural', descripcion: 'Verdulerías y saludable',
        preview: { bg: '#2E7D32', text: '#FFFFFF', footer: '#1B5E20' },
        carta_qr: { header_bg: '#2E7D32', header_text_color: '#FFFFFF', footer_bg: '#1B5E20', footer_text_color: '#FFFFFF', color_fondo: '#F1F8E9', logo_tamano: 'mediano', tarjeta_radio: 'redondeado', tarjeta_sombra: false }
    },
    {
        id: 'cafe', nombre: 'Café', descripcion: 'Cafeterías y pastelerías',
        preview: { bg: '#A0522D', text: '#FFFFFF', footer: '#3E2723' },
        carta_qr: { header_bg: '#A0522D', header_text_color: '#FFFFFF', footer_bg: '#3E2723', footer_text_color: '#FFFFFF', color_fondo: '#FFF8F0', logo_tamano: 'mediano', tarjeta_radio: 'redondeado', tarjeta_sombra: true }
    },
    {
        id: 'marino', nombre: 'Marino', descripcion: 'Profesional y elegante',
        preview: { bg: '#1E3A5F', text: '#FFFFFF', footer: '#111827' },
        carta_qr: { header_bg: '#1E3A5F', header_text_color: '#FFFFFF', footer_bg: '#111827', footer_text_color: '#FFFFFF', color_fondo: '#F0F4F8', logo_tamano: 'mediano', tarjeta_radio: 'redondeado', tarjeta_sombra: false }
    },
    {
        id: 'minimal', nombre: 'Minimal', descripcion: 'Limpio y moderno',
        preview: { bg: '#1a1c1d', text: '#FFFFFF', footer: '#F3F4F6' },
        carta_qr: { header_bg: '#1a1c1d', header_text_color: '#FFFFFF', footer_bg: '#F3F4F6', footer_text_color: '#6B7280', color_fondo: '#FFFFFF', logo_tamano: 'mediano', tarjeta_radio: 'cuadrado', tarjeta_sombra: true }
    },
];

export const FUENTES_DISPONIBLES = [
    { value: "'Inter', sans-serif", label: 'Inter' },
    { value: "'Roboto', sans-serif", label: 'Roboto' },
    { value: "'Poppins', sans-serif", label: 'Poppins' },
    { value: "'Open Sans', sans-serif", label: 'Open Sans' },
    { value: "'Lato', sans-serif", label: 'Lato' },
    { value: "'Montserrat', sans-serif", label: 'Montserrat' },
    { value: "'Nunito', sans-serif", label: 'Nunito' },
];

export const OPCIONES_REDONDEZ = [
    { value: '0px', label: 'Cuadrado', emoji: '⬜' },
    { value: '8px', label: 'Suave', emoji: '▫' },
    { value: '12px', label: 'Medio', emoji: '🔲' },
    { value: '20px', label: 'Redondeado', emoji: '🔴' },
    { value: '50px', label: 'Muy Redondeado', emoji: '⚪' },
];
